module.exports = __webpack_public_path__ + "img/12.cbfa5f00.jpg";